import React from 'react'
import TopicForm from './TopicForm'
import {Modal} from 'react-bootstrap'


const TopicEdit = ({show,handleModalClose,handleSubmit,topic}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Thema bearbeiten</Modal.Title>
        </Modal.Header>
          <TopicForm
             handleSubmit={handleSubmit} topic={topic}
            />
        </Modal>
  </div>
)

export default TopicEdit
